'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _es6Promise = require('es6-promise');

var _abstractClient = require('./abstract-client');

var _abstractClient2 = _interopRequireDefault(_abstractClient);

var AjaxClient = (function (_AbstractClient) {
  _inherits(AjaxClient, _AbstractClient);

  function AjaxClient() {
    _classCallCheck(this, AjaxClient);

    _get(Object.getPrototypeOf(AjaxClient.prototype), 'constructor', this).apply(this, arguments);
  }

  _createClass(AjaxClient, [{
    key: 'setToken',
    value: function setToken(token) {
      this.credentials.token = token;
    }
  }, {
    key: 'createXhr',
    value: function createXhr() {
      return new XMLHttpRequest();
    }
  }, {
    key: 'sendRequest',
    value: function sendRequest(method, url, params, overrides) {
      var _this = this;

      return new _es6Promise.Promise(function (resolve, reject) {
        var request = _this.createXhr();
        request.open(method, _this.apiBase + url, true);
        request.responseType = 'text';

        request.setRequestHeader(_this.getAuthorizationHeaderName(), 'Token ' + _this.credentials.token);
        request.setRequestHeader('Content-Type', 'application/json');

        if (overrides && overrides.headers) {
          (function () {
            var mergedHeaders = _extends({}, _this.headers, overrides.headers);
            Object.keys(mergedHeaders).forEach(function (key) {
              request.setRequestHeader(key, mergedHeaders[key]);
            });
          })();
        } else {
          Object.keys(_this.headers).forEach(function (key) {
            request.setRequestHeader(key, _this.headers[key]);
          });
        }

        request.onreadystatechange = function () {
          if (request.readyState === 4 && request.status !== 0) {
            var headers = (request.getAllResponseHeaders() || '').trim().split('\r\n').reduce(function (map, line) {
              var _line$split = line.split(':');

              var _line$split2 = _toArray(_line$split);

              var field = _line$split2[0];

              var rest = _line$split2.slice(1);

              var fieldName = field.trim().toLowerCase();
              var priorValue = map[fieldName];
              map[fieldName] = (priorValue ? priorValue + '\n' : '') + rest.join(':');
              return map;
            }, {});

            resolve({
              status: request.status,
              body: request.responseText || '',
              headers: headers
            });
          }
        };

        request.onerror = function (error) {
          return reject(error);
        };
        request.ontimeout = function () {
          return resolve({ wasNetworkTimeout: true });
        };

        if (params) {
          request.send(JSON.stringify(params));
        } else {
          request.send();
        }
      });
    }
  }]);

  return AjaxClient;
})(_abstractClient2['default']);

exports['default'] = AjaxClient;
module.exports = exports['default'];